<template>
    <div class="constructionRequirements__icons">
        <img :src="'/wp-content/themes/rigips/images/icon/' + feature.icon" :alt="feature.name"
             v-for="feature in features">
    </div>
</template>

<script>
    export default {
        name: 'CalculationConstructionFeatureList',
        props: {
            features: {
                type: Array,
                default: [],
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/feature/ConstructionFeatureList.vue